import $ from "jquery";
import "datatables.net-dt";
import filteringObject from "../abstracts/filteringObject";

const utilsDatatable = () => {
  const init = () => {
    execute();
  };

  const handleSearch = (table, searchEl) => {
    if (searchEl) {
      $(document).on("keyup", searchEl, function () {
        table.search(this.value).draw();
      });
    }
  };

  const execute = () => {
    const el = {
      main: ".js-datatable",
    };

    if ($(el.main).length === 0) return;

    $(el.main).each(function () {
      const nameTable = $(this).data("table-name");
      const searchEl = $(this).data("search_input");
      const lengthMenu = $(this).data("length_menu");
      const option = $(this).data();
      let optionDT = filteringObject(option, (a, k, v) => {
        if (k.startsWith("dt_")) {
          const key = k.slice(3).replace(/_([a-z])/g, function (_, letter) {
            return letter.toUpperCase();
          });

          if (v === "true" || v === "false") {
            a[key] = v === "true";
          } else {
            a[key] = /^\d+$/.test(v) ? parseInt(v) : v;
          }
        }
      });
      const optionLang = filteringObject(option, (a, k, v) => {
        if (k.startsWith("lang.")) {
          if (v === "true" || v === "false") {
            a[k.slice(5)] = v === "true";
          } else {
            a[k.slice(5)] = /^\d+$/.test(v) ? parseInt(v) : v;
          }
        }
      });

      let ajaxSettings = {};

      if (optionDT.ajax) {
        ajaxSettings = {
          serverSide: true,
          processing: true,
          ajax: optionDT.ajax,
          autoWidth: false,
        };
      }

      const table = $(this).DataTable({
        layout: {
          topStart: "",
          topEnd: "",
          bottomStart: "info",
          bottomEnd: "paging",
        },
        ...ajaxSettings,
        language: {
          lengthMenu: lengthMenu,
          ...optionLang,
        },
        ...optionDT,
      });

      if (nameTable) {
        window[nameTable] = table;
      }

      handleSearch(table, searchEl);
    });
  };
  init();
};

try {
  utilsDatatable();
} catch (error) {
  console.error("utilsDatatable", error);
}
